import { PointerObj } from '@saas/interfaces/core'

export const makePointer = (className: string, id: string): PointerObj => ({
    __type: 'Pointer',
    className,
    objectId: id,
})

export default null
